<template>
    <button
        class="inline-flex text-center justify-center items-center px-4 py-2 bg-lifeworx-red-500 border border-transparent rounded-md font-bold text-white uppercase tracking-widest hover:bg-lifeworx-red-600 active:bg-lifeworx-red-500 focus:outline-none focus:ring-2 focus:ring-lifeworx-red-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 transition ease-in-out duration-150"
    >
        <slot />
    </button>
</template>
